const AvailableThemes = Object.freeze({
  LIGHT: 'light',
  DARK: 'dark',
} as const);

export type AvailableThemes = (typeof AvailableThemes)[keyof typeof AvailableThemes];

export default AvailableThemes;
